<template>
	<mobile-card :showFooter="showFooter" paddingTop="0.5vh">
		<template v-slot:title>
			<div style="float: left; text-align: left">{{ pageText.ticket_info }}</div>
			<div style="float: right">
				<van-radio-group v-model="invoiceIsDelay" class="flex-checkbox-group" :icon-size="12">
					<van-radio class="flex-checkbox-item2" name="0" checked-color="#005423">
						{{ pageText.open_immediately }}
					</van-radio>
					<van-radio class="flex-checkbox-item2" name="1" checked-color="#005423">{{ pageText.open_later }}</van-radio>
				</van-radio-group>
			</div>
		</template>
		<template v-slot:content>
			<div class="flex-form-info">
				<van-radio-group v-model="ticketType" class="flex-checkbox-group" :icon-size="14">
					<van-radio class="flex-checkbox-item" name="1" checked-color="#005423">{{ pageText.person_title }}</van-radio>
					<van-radio v-if="detail.enableUseCompanyTitle" class="flex-checkbox-item" name="2" checked-color="#005423">
						{{ pageText.company_title }}
					</van-radio>
				</van-radio-group>
			</div>

			<div class="flex-form-info" v-if="showPerson || !detail.enableUseCompanyTitle">
				<div class="left" style="line-height: 33px">{{ pageText.name }}：</div>
				<div
					class="right"
					style="width: 80%; border-bottom: 1px #dcdee0 solid; border-top: 0px; border-left: 0px; border-right: 0px">
					<van-field
						input-align="right"
						label-align="left"
						size="14px"
						:placeholder="pageText.name_placeholder"
						style="padding: 0px; margin: 0px; height: 31px; line-height: 32px; padding-right: 5px"
						v-model="detail.userName" />
				</div>
			</div>
			<!--            <div class="flex-form-info" v-if="showPerson">-->
			<!--                <van-field label="税号：" input-align="right" label-align="left" size="14px" placeholder="请输入税号"-->
			<!--                           style="padding: 0px" v-model="detail.taxNumber"/>-->
			<!--            </div>-->
			<div v-else>
				<div class="flex-form-info">
					<span>{{ pageText.name }}：</span>
					<span>{{ detail.name }}</span>
				</div>
				<div class="flex-form-info">
					<span>{{ pageText.taxNumber }}：</span>
					<span>{{ detail.taxNumber }}</span>
				</div>
				<div class="flex-form-info" style="height: 14px; margin-bottom: 10px" v-if="!showDetail">
					<span class="link" style="display: block; font-size: 12px" @click.prevent="showDetail = true">
						{{ pageText.view_detail }}
					</span>
				</div>
				<div class="flex-form-info" v-if="showDetail">
					<span>{{ pageText.address }}：</span>
					<span>{{ detail.address }}</span>
				</div>
				<div class="flex-form-info" v-if="showDetail">
					<span>{{ pageText.tele }}：</span>
					<span>{{ detail.tele }}</span>
				</div>
				<div class="flex-form-info" v-if="showDetail">
					<span>{{ pageText.depositBank }}：</span>
					<span>{{ detail.depositBank }}</span>
				</div>
				<div class="flex-form-info" v-if="showDetail">
					<span>{{ pageText.bank }}：</span>
					<span>{{ detail.bank }}</span>
				</div>
				<div class="flex-form-info" style="height: 14px; margin-bottom: 10px" v-if="showDetail">
					<span class="link" style="display: block; font-size: 12px" @click.prevent="showDetail = false">
						{{ pageText.fold_detail }}
					</span>
				</div>
			</div>
			<div class="flex-form-info" v-if="detail.estate">
				<div class="left" style="line-height: 33px; min-width: 110px">{{ pageText.estate_date }}：</div>
				<div
					class="right"
					style="width: 70%; border-bottom: 1px #dcdee0 solid; border-top: 0px; border-left: 0px; border-right: 0px">
					<van-field
						readonly
						clickable
						name="calendar"
						input-align="right"
						:value="estateDate"
						:placeholder="pageText.estate_date_placeholder"
						style="padding: 0px; margin: 0px; height: 31px; line-height: 32px; padding-right: 5px"
						@click="dateShow = true" />
					<van-calendar
						v-model="dateShow"
						type="range"
						:min-date="minDate"
						:max-date="maxDate"
						:show-confirm="false"
						@confirm="onConfirm" />
				</div>
			</div>

			<div class="flex-form-info" style="margin-top: 10px" v-if="!showRemark">
				<div class="left link" style="font-size: 12px" @click.prevent="showRemark = !showRemark">
					{{ pageText.ticket_remark }}
				</div>
			</div>
			<div class="flex-form-info" style="margin-top: 10px" v-if="showRemark">
				<div class="left link" style="font-size: 12px" @click.prevent="showRemark = !showRemark">
					{{ pageText.collapse_ticket_remark }}
				</div>
			</div>
			<div class="flex-form-info" style="height: auto" v-if="showRemark">
				<div style="width: 100%">
					<van-field
						input-align="left"
						label-align="right"
						size="14px"
						class="text-field"
						style="padding: 0px; margin: 0px; padding-right: 5px; text-align: right"
						v-model="remark"
						rows="2"
						autosize
						type="textarea"
						:maxlength="remarkLimit"
						show-word-limit
						:placeholder="pageText.ticket_remark" />
				</div>
			</div>
		</template>

		<template v-if="detail.enableUseCompanyTitle" v-slot:footer>
			<div class="flex-form-footer">
				<mobile-button color="#005423" class="ticket-btn-font" @click="search">{{ pageText.search }}</mobile-button>
				<mobile-button color="#005423" class="ticket-btn-font" @click="addNew">{{ pageText.add }}</mobile-button>
			</div>
		</template>
	</mobile-card>
</template>
<script>
import mobileCard from 'components/mobile-card/index'
import MobileButton from 'components/mobile-button/index'

export default {
	name: 'ticketInfo',
	props: {
		detail: Object,
		chooceJG: Boolean
	},
	components: {
		MobileButton,
		mobileCard
		// ticketAddDialog,
	},

	computed: {
		showFooter() {
			return this.ticketType === '2'
		},
		showPerson() {
			return this.ticketType === '1' || !this.detail.enableUseCompanyTitle
		}
	},
	watch: {
		ticketType(val) {
			this.$emit('changeTicketType', Number(val))
		}
	},
	data() {
		return {
			showTicketAddDialog: false,
			enableUseCompanyTitle: true,
			ticketType: '1',
			invoiceIsDelay: '0',
			remark: '',
			showDetail: false,
			showRemark: false,
			remarkLimit: 100,
			estateDate: '',
			estateStartDate: '',
			estateEndDate: '',
			dateShow: false,
			minDate: new Date(2020, 0, 1),
			maxDate: new Date(2030, 0, 31),
			infoList: [
				{
					name: '姓名',
					value: '12345'
				},
				{
					name: '姓名',
					value: '12345'
				},
				{
					name: '姓名',
					value: '12345'
				}
			],
			organ: {},
			pageText: {
				ticket_info: this.$t('pay_ticket.ticket_info'),
				open_immediately: this.$t('pay_ticket.open_immediately'),
				open_later: this.$t('pay_ticket.open_later'),
				person_title: this.$t('pay_ticket.person_title'),
				company_title: this.$t('pay_ticket.company_title'),
				name: this.$t('pay_ticket.name'),
				name_placeholder: this.$t('pay_ticket.name_placeholder'),
				estate_date: this.$t('pay_ticket.estate_date'),
				estate_date_placeholder: this.$t('pay_ticket.estate_date_placeholder'),
				ticket_remark: this.$t('pay_ticket.ticket_remark'),
				collapse_ticket_remark: this.$t('pay_ticket.collapse_ticket_remark'),
				taxNumber: this.$t('pay_ticket.organ_model.taxNumber'),
				view_detail: this.$t('pay_ticket.organ_model.view_detail'),
				address: this.$t('pay_ticket.organ_model.address'),
				tele: this.$t('pay_ticket.organ_model.tele'),
				depositBank: this.$t('pay_ticket.organ_model.depositBank'),
				bank: this.$t('pay_ticket.organ_model.bank'),
				fold_detail: this.$t('pay_ticket.organ_model.fold_detail'),
				search: this.$t('pay_ticket.search'),
				add: this.$t('pay_ticket.add')
			}
		}
	},
	methods: {
		addNew() {
			this.$emit('add-organ')
		},
		search() {
			this.$emit('search-organ')
		},
		getTicketTitleAndTaxNum() {
			let title = ''
			if (this.ticketType === '1') {
				title = this.detail.userName
			} else if (this.ticketType === '2') {
				title = this.detail.name
			}
			return {
				title: title,
				taxNumber: this.detail.taxNumber,
				depositBank: this.detail.depositBank,
				tele: this.detail.tele,
				bank: this.detail.bank,
				address: this.detail.address,
				invoiceIsDelay: Number(this.invoiceIsDelay),
				remark: this.remark,
				estateStartDate: this.estateStartDate,
				estateEndDate: this.estateEndDate
			}
		},
		formatDate(date) {
			let month = date.getMonth() + 1
			if (month < 10) {
				month = `0${month}`
			}
			let day = date.getDate()
			if (day < 10) {
				day = `0${day}`
			}
			console.log('日期:', `${date.getFullYear()}-${month}-${day}`)
			return `${date.getFullYear()}-${month}-${day}`
		},
		onConfirm(date) {
			const [start, end] = date
			this.dateShow = false
			this.estateStartDate = this.formatDate(start)
			this.estateEndDate = this.formatDate(end)
			this.estateDate = `${this.estateStartDate} 至 ${this.estateEndDate}`
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (this.chooceJG) {
				this.ticketType = '2'
			}
		})
	},
	created() {}
}
</script>
<style lang="scss" scoped>
.flex-checkbox-group {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	color: #005423;
	width: 100%;

	.flex-checkbox-item {
		font-size: 14px;
		padding-right: 10px;
		//width: 24%;
	}

	.flex-checkbox-item2 {
		font-size: 12px;
		padding-left: 5px;
		// width: 80px;
	}
}

.ticket-btn-font {
	font-size: 12px;
	margin-right: 8px;
}

.link {
	text-decoration: underline;
	color: #005423;
}

/deep/ .flex-form-info {
	height: 38px;
	padding-top: 0px;
}

/deep/ .van-field__label--left {
	text-align: left;
}

/deep/ .card-title-div {
	width: 100%;
}

/*.flex-form-info {*/
/*    padding: 5px;*/
/*    display: flex;*/

/*    .row-info {*/
/*        padding-top: 5px;*/
/*        padding-bottom: 5px;*/

/*        span {*/
/*            margin-right: 10px;*/
/*        }*/
/*    }*/
/*}*/
</style>
